import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="charges-toggle"
export default class extends Controller {

  static targets = ['section']

  toggle() {
    this.sectionTargets.forEach(e => {
      e.classList.toggle('hidden');
    });
  }
}
